
import { defineComponent, PropType } from 'vue';

/** name 参数支持的值 */
type NameType =
  | 'back'
  | 'cloud'
  | 'my'
  | 'notification'
  | 'rating'
  | 'search'
  | 'timetable'
  | 'edit-square'
  | 'edit'
  | 'delete'
  | 'shrink'
  | 'arrawsalt'
  | 'undo'
  | 'contract'
  | 'expand'
  | 'eye'
  | 'eye-slash'
  | 'plus'
  | 'plus-circle'
  | 'heart'
  | 'heart-fill'
  | 'star'
  | 'star-fill'
  | 'reaction'
  | 'chat'
  | 'door-open'
  | 'pencil-square'
  | 'right'
  | 'left'
  | 'menu-button'
  | 'question-circle';

export default defineComponent({
  props: {
    name: { type: String as PropType<NameType>, required: true },
    width: { type: [String, Number], default: undefined },
    heigth: { type: [String, Number], default: undefined },
    size: { type: [String, Number], default: undefined },
  },
  computed: {
    parsedWidth(): string {
      if (this.width !== undefined) {
        return typeof this.width === 'number' ? `${this.width}px` : this.width;
      }
      if (this.size !== undefined) {
        return typeof this.size === 'number' ? `${this.size}px` : this.size;
      }
      return '20px';
    },
    parsedHeight(): string {
      if (this.heigth !== undefined) {
        return typeof this.heigth === 'number' ? `${this.heigth}px` : this.heigth;
      }
      if (this.size !== undefined) {
        return typeof this.size === 'number' ? `${this.size}px` : this.size;
      }
      return '20px';
    },
  },
});
